const IN_PROGRESS = 'in_progress';
const COMPLETED = 'completed';
const PENDING = 'pending';

export function coerceLineStatus(raw) {
  const s = String(raw || '').trim().toLowerCase();
  if (s === IN_PROGRESS || s === 'in_service' || s === 'started') return IN_PROGRESS;
  if (s === COMPLETED || s === 'complete' || s === 'done') return COMPLETED;
  return PENDING;
}

export function partitionVisitServices(services) {
  const list = Array.isArray(services) ? services : [];
  const inProgress = [];
  const pending = [];
  const completed = [];
  list.forEach((s) => {
    if (typeof s === 'string') {
      const name = s.trim();
      if (name) pending.push({ name });
      return;
    }
    if (!s || typeof s !== 'object') return;
    const name = String(s.name || s.service_name || s.label || '').trim();
    if (!name) return;
    const staff = Array.isArray(s.staff)
      ? s.staff.map((p) => p?.name || p?.id).filter(Boolean).join(', ')
      : '';
    const row = { name, staff, raw: s };
    const st = coerceLineStatus(s.service_status);
    if (st === IN_PROGRESS) inProgress.push(row);
    else if (st === COMPLETED) completed.push(row);
    else pending.push(row);
  });
  return { inProgress, pending, completed };
}

/** Front desk tab/badge: treat active + in-progress lines as in service. */
export function effectiveCheckinStatus(item) {
  const status = String(item?.status || 'active').toLowerCase();
  if (status === 'completed' || status === 'cancelled') return status;
  const { inProgress } = partitionVisitServices(item?.selected_services);
  if (inProgress.length) return 'in_service';
  return status || 'active';
}

function lineLabel(row) {
  return row.staff ? `${row.name} (${row.staff})` : row.name;
}

export function deskServiceSummary(services) {
  const parts = partitionVisitServices(services);
  const chunks = [];
  if (parts.inProgress.length) {
    chunks.push(`In progress · ${parts.inProgress.map(lineLabel).join(', ')}`);
  }
  if (parts.pending.length) {
    chunks.push(`Queued · ${parts.pending.map((r) => r.name).join(', ')}`);
  }
  if (parts.completed.length) {
    chunks.push(`Done · ${parts.completed.map((r) => r.name).join(', ')}`);
  }
  return chunks.join(' · ');
}

export function deskServiceShortLabel(services) {
  const { inProgress, pending, completed } = partitionVisitServices(services);
  if (inProgress.length) {
    return inProgress.map(lineLabel).join(', ');
  }
  if (pending.length) {
    return pending.map((r) => r.name).join(', ');
  }
  if (completed.length) {
    return completed.map((r) => r.name).join(', ');
  }
  return '';
}

/** Front desk line row: name, status, optional stylist from line.staff */
export function deskServiceLineDetail(line) {
  if (!line || typeof line !== 'object') return null;
  const name = String(line.name || line.service_name || '').trim();
  if (!name) return null;
  const st = coerceLineStatus(line.service_status);
  const staff = Array.isArray(line.staff)
    ? line.staff.map((p) => String(p?.name || '').trim()).filter(Boolean).join(', ')
    : '';
  return { name, status: st, staff };
}
